import {
  MBD_ITEMS,
  MBD_TYPE,
} from '@shared/constants/meaningful-behaviour-data';

const buildHotelSaveAttributes = ({
  hotelId,
  isCta,
  saveStatus,
}: {
  hotelId: string;
  saveStatus?: string;
  isCta?: boolean;
}) => {
  if (isCta) {
    const { id, name } = MBD_ITEMS[MBD_TYPE.HOTEL_SAVE_CTA];

    return {
      id: `${id}_${hotelId}_${saveStatus}`,
      name,
    };
  }

  const { id, name } = MBD_ITEMS[MBD_TYPE.HOTEL_SAVE_SUCCESS];

  return {
    id: `${id}_${hotelId}`,
    name,
  };
};

export { buildHotelSaveAttributes };
